import { FileService } from "../../../services/FileService";
import setToast from "../../../helpers/toaster.helper";
import { ToasterType } from "../toaster/toaster.model";

export const messageLogDownLoad = (FileKey, isBulk?: boolean) => {
    if (FileKey !== undefined) {
        if (!isBulk)
            setToast(`Message logs download started.`, ToasterType.INFO)
        return FileService.downLoadFile(FileKey).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Messagelog.zip");
            link.click();
            if (!isBulk)
                setToast(`Message logs downloaded successfully. You can check it!`, ToasterType.SUCCESS)
            return false
        }).catch((err) => {
            setToast(`Message logs downloaded fail.`, ToasterType.DANGER)
        })
    }
}

export const ExportComponent = (props: any) => {
    return (
        <div onClick={async () => {
            if (props.FileKey !== null && props.IsDelete === false) {
                messageLogDownLoad(props.FileKey);
            } else if (props.id !== null && props.IsDelete === true) {
                props.onDeleteFile();
            }
        }} className={`d-flex justify-center color-grid-label-font ${props.ClassName}`} key={props.Id}>
            {!!props.Icon && <props.Icon className={"my-auto mr-1"} />}
        </div>
    );
};
